import React from "react";

const SIZE = 320;
const R = SIZE / 2;

const slicePath = (i, n) => {
  const a0 = ((i * 360) / n - 90) * (Math.PI / 180);
  const a1 = (((i + 1) * 360) / n - 90) * (Math.PI / 180);
  return `M${R},${R} L${R + R * Math.cos(a0)},${R + R * Math.sin(a0)} A${R},${R} 0 0 1 ${R + R * Math.cos(a1)},${R + R * Math.sin(a1)} Z`;
};

export const WheelSvg = ({ slots }) => (
  <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className="w-full h-full" data-testid="spin-wheel-svg">
    {slots.map((s, i) => {
      const mid = ((i + 0.5) * 360) / slots.length;
      const dark = s.color === "#FFD700";
      return (
        <g key={s.id}>
          <path d={slicePath(i, slots.length)} fill={s.color} stroke="#FFD700" strokeWidth="3" />
          <text
            x={R}
            y={R - R * 0.62}
            transform={`rotate(${mid} ${R} ${R})`}
            textAnchor="middle"
            fill={dark ? "#06170D" : "#FFF8EC"}
            fontSize="15"
            fontWeight="800"
            fontFamily="Bebas Neue, sans-serif"
            letterSpacing="0.5"
          >
            {s.label}
          </text>
        </g>
      );
    })}
    <circle cx={R} cy={R} r="30" fill="#FFF8EC" stroke="#FFD700" strokeWidth="5" />
    <text x={R} y={R + 9} textAnchor="middle" fontSize="26">🍬</text>
  </svg>
);
